// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-32{margin-top:128px !important;margin-bottom:128px !important}.designer:nth-child(even){padding-top:100px}@media only screen and (max-width: 599px){.designer:nth-child(even){padding-top:0}}.wrapper{max-width:400px}.wrapper h2{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto;font-family:\"Tiempos Fine\",serif;font-size:3.2rem;text-transform:uppercase}.wrapper p{font-size:1.1rem}", ""]);
// Exports
module.exports = exports;
